var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedinFooter = function SvgLinkedinFooter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    x: 0.5,
    y: 0.5,
    stroke: "currentColor",
    strokeOpacity: 0.2,
    rx: 7.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.541 13.508H8.262V24h3.279zm.295-3.606A1.887 1.887 0 0 0 9.961 8H9.9a1.902 1.902 0 1 0 0 3.803 1.886 1.886 0 0 0 1.935-1.842zM24 17.626c0-3.154-2.007-4.38-4-4.38a3.74 3.74 0 0 0-3.318 1.692h-.092v-1.43h-3.082V24h3.279v-5.58a2.177 2.177 0 0 1 1.967-2.348h.125c1.042 0 1.816.656 1.816 2.308V24h3.279z"
  })));
};
export default SvgLinkedinFooter;